export var initJqueryDateYearScroller = function () {
    document.addEventListener('wheel', function (e) {
        var target = e.target;
        if (!target.classList.contains('ui-datepicker-year')) {
            return;
        }
        var checked = target.querySelector('option:checked');
        if (e.deltaY > 1) {
            var nextElement = checked.nextElementSibling;
            if (nextElement) {
                nextElement.selected = true;
                jQuery(nextElement).trigger('change');
            }
        }
        if (e.deltaY < -1) {
            var prevElement = checked.previousElementSibling;
            if (prevElement) {
                prevElement.selected = true;
                jQuery(prevElement).trigger('change');
            }
        }
    });
};
